import React from "react";
import { useSelector } from "react-redux";
import DataTable from "src/components/Table";
import { useIsMobile } from "src/hooks/useIsMobile";
import { Ticket } from "src/types";
import { managerTableHeaders } from "../constant";
import ManagerListItem from "./ManagerListItem";
import ManagerTableRow from "./ManagerTableRow";
import { getIsTicketsLoading, getTickets } from "src/redux/selectors/resources";
import styled from "styled-components";

const ManagerTicketsWrapper = () => {
  const isTicketsLoading = useSelector(getIsTicketsLoading);
  const tickets = useSelector(getTickets);

  const { isMobile } = useIsMobile();

  if (isMobile) {
    return (
      <>
        {tickets.map((ticket: Ticket) => (
          <ManagerListItem ticket={ticket} key={ticket.wonum} />
        ))}
      </>
    );
  }
  return (
    <WorkRequestTableSizer>
      <DataTable isLoading={isTicketsLoading} headers={managerTableHeaders}>
        {tickets?.map((ticket: Ticket) => (
          <ManagerTableRow key={ticket.wonum} ticket={ticket} />
        ))}
      </DataTable>
    </WorkRequestTableSizer>
  );
};

export default ManagerTicketsWrapper;

/* Manager table font/padding override — comment out the block below to revert to default */
const WorkRequestTableSizer = styled.div`
  table th,
  table td {
    font-size: 12px; /* was 14px — revert: change back to 14px */
    padding: 11px 15px; /* was 15px — revert: change back to 15px */
  }
`;
